import React, { useState } from "react";
import classNames from 'classnames';

const SettingsTemplateType = ({ value, onChange }) => {

  const types = [
    { id: 'horizontal', name: i18n.t('import_rss.horizontal') },
    { id: 'vertical', name: i18n.t('import_rss.vertical') },
    { id: 'none', name: i18n.t('import_rss.none') }
  ]

  const button = (item, i) => {
    const buttonClasses = classNames(
      'btn', 'btn-form',
      {
        'active': value === item.id
      }
    );
    return <button key={i} className={buttonClasses} onClick={() => onChange(item.id)}>{item.name}</button>
  }

  return (
    <div className="btn-group">
      {types.map(button)}
    </div>
  );
};

export default SettingsTemplateType;
